<div class="shadow sm:rounded-lg flex flex-col bg-surface divide-y divide-separator">
  <!-- Navigation bar: toggle + arrows -->
  <div class="flex items-center justify-end gap-3 px-4 py-2">
    <!-- Month / Woche toggle -->
    <div class="flex rounded-md border border-separator overflow-hidden text-sm">
      <button
        type="button"
        (click)="viewMode = 'month'"
        class="px-3 py-1 font-medium transition-colors"
        [class.bg-primary]="viewMode === 'month'"
        [class.text-on-primary]="viewMode === 'month'"
        [class.bg-surface]="viewMode !== 'month'"
        [class.text-fg-muted]="viewMode !== 'month'"
      >
        Monat
      </button>
      <button
        type="button"
        (click)="viewMode = 'week'"
        class="px-3 py-1 font-medium border-l border-separator transition-colors"
        [class.bg-primary]="viewMode === 'week'"
        [class.text-on-primary]="viewMode === 'week'"
        [class.bg-surface]="viewMode !== 'week'"
        [class.text-fg-muted]="viewMode !== 'week'"
      >
        Woche
      </button>
    </div>

    <!-- Prev / Next arrows -->
    <div class="grid grid-cols-2 gap-2">
      <button
        type="button"
        aria-label="calendar backward"
        (click)="previous()"
        class="hover:text-fg-faint text-fg-subtle border border-transparent rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
      >
        <app-ng-icon class="text-xl" name="heroChevronLeft"></app-ng-icon>
      </button>

      <button
        type="button"
        aria-label="calendar forward"
        (click)="next()"
        class="hover:text-fg-faint text-fg-subtle border border-transparent rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
      >
        <app-ng-icon class="text-xl" name="heroChevronRight"></app-ng-icon>
      </button>
    </div>
  </div>

  @if (viewMode === 'month') {
    @let status = weekStatusMessage;
    <div
      [class]="monthStatusLaneClasses(status)"
      role="status"
      aria-live="polite"
      data-month-status-lane
    >
      @if (status) {
        {{ status.text }}
      } @else {
        <span aria-hidden="true">&nbsp;</span>
      }
    </div>

    <div class="flex flex-row self-center">
      <app-month-calendar
        [month]="months[0]"
        [work]="work"
        (selectedDateChange)="selectDate($event)"
        [selectedDate]="selectedDate"
        [warningDays]="warningDays"
        class="hidden 2xl:block"
      ></app-month-calendar>
      <app-month-calendar
        [month]="months[1]"
        [work]="work"
        (selectedDateChange)="selectDate($event)"
        [selectedDate]="selectedDate"
        [warningDays]="warningDays"
        class="hidden md:block"
      ></app-month-calendar>
      <app-month-calendar
        [month]="months[2]"
        [work]="work"
        (selectedDateChange)="selectDate($event)"
        [selectedDate]="selectedDate"
        [warningDays]="warningDays"
      ></app-month-calendar>
    </div>
  } @else {
    <app-week-calendar
      [selectedDate]="selectedDate"
      [workItems]="workItems"
      [timerItems]="timerItems"
      [warningDays]="warningDays"
      [statusMessage]="weekStatusMessage"
      [pendingTimeEntryChange]="pendingTimeEntryChange"
      (selectedDateChange)="selectDate($event)"
      (createWork)="createWork.emit($event)"
      (editWork)="editWork.emit($event)"
      (showTimer)="showTimer.emit($event)"
      (timeEntryChange)="timeEntryChange.emit($event)"
    ></app-week-calendar>
  }

  <div class="sm:rounded-b-lg">
    <router-outlet></router-outlet>
  </div>
</div>
